import { useCallback } from 'react';
import { useLocalizeOption } from '@mews-commander/form';
import { EnterpriseProfilePrivilegesEnumNames } from '@mews-commander/legacy-data-structures';

const PRIVILEGE_KEY_PREFIX = 'EnterpriseProfilePrivileges';

export const useLocalizePrivilege = () => {
    const localizeOption = useLocalizeOption();
    return useCallback(
        (privilege: EnterpriseProfilePrivilegesEnumNames) => localizeOption(PRIVILEGE_KEY_PREFIX, privilege),
        [localizeOption]
    );
};
